import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-fill",
  "use": "icon-circle-fill-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle-fill\">\r\n   \r\n   \r\n        <circle id=\"icon-circle-fill_Oval\" cx=\"80\" cy=\"80\" r=\"75\" />\r\n   \r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol